module.exports = __webpack_public_path__ + "static/media/lingo.49274394.png";